import { anatomy } from "@chakra-ui/theme-tools";

export const selectDropdownAnatomy: any = anatomy("SelectDropdown").parts("button", "list", "item");
